
import { Mixins } from "vue-property-decorator";

export default class SignUp extends Mixins() {
}
